/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type Logo1Svg2IconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function Logo1Svg2Icon(props: Logo1Svg2IconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      xmlnsXlink={"http://www.w3.org/1999/xlink"}
      fill={"none"}
      viewBox={"0 0 147 28"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <g clipPath={"url(#a)"}>
        <path
          fill={"#DC0A3C"}
          d={
            "M4.228 27.004q-1.418 0-2.165-.784t-.747-2.203V3.297q0-2.95 2.95-2.95h9.072q4.406 0 6.794 2.129 2.39 2.127 2.39 5.936 0 2.949-1.53 4.928-1.495 1.94-4.294 2.65 1.978.598 3.248 2.875l2.314 4.293q.785 1.42.3 2.651-.486 1.194-2.353 1.195-1.232 0-2.016-.523t-1.344-1.605l-3.584-6.608q-.56-1.046-1.381-1.419-.822-.373-1.942-.373H7.103v7.541q0 1.419-.747 2.203-.709.784-2.128.784m2.875-14.71h5.19q4.666 0 4.666-3.733 0-3.696-4.667-3.696H7.103zM36.72 27.078q-3.248 0-5.6-1.157-2.315-1.194-3.584-3.323-1.232-2.165-1.232-5.077 0-2.838 1.195-4.965 1.232-2.166 3.322-3.36 2.13-1.232 4.891-1.232 3.995 0 6.347 2.538 2.352 2.502 2.352 6.795 0 1.419-1.755 1.419H31.68q.3 2.165 1.568 3.173 1.307.97 3.584.97.897 0 2.016-.186a8.5 8.5 0 0 0 2.203-.747q1.083-.522 1.83-.186a1.68 1.68 0 0 1 1.007 1.045q.3.747 0 1.568-.261.784-1.232 1.307a10.6 10.6 0 0 1-2.912 1.045 13 13 0 0 1-3.024.373m-.784-15.381q-1.791 0-2.912 1.083-1.083 1.082-1.344 3.024h8.064q-.224-4.107-3.808-4.107m15.04 15.307q-2.913 0-2.913-2.875V10.876q0-2.838 2.763-2.838t2.762 2.838v.672q1.344-3.323 5.563-3.584.933-.075 1.419.485.522.522.56 1.755.075 1.157-.485 1.829-.523.672-1.792.821l-.86.075q-4.18.41-4.18 4.256v6.944q0 2.874-2.838 2.875m19.603.074q-3.51 0-5.19-1.941-1.642-1.942-1.642-5.824v-8.437q0-2.838 2.8-2.838 2.838 0 2.837 2.838v8.586q0 3.249 2.8 3.248 1.605 0 2.614-1.12 1.045-1.157 1.045-3.024v-7.69q0-2.838 2.8-2.838 2.838 0 2.838 2.838v13.253q0 2.874-2.726 2.875-1.344 0-2.053-.747-.71-.747-.71-2.09-1.828 2.91-5.413 2.911m18.55-.074q-2.838 0-2.838-2.875V10.876q0-2.838 2.762-2.838t2.763 2.838v.112a5.77 5.77 0 0 1 2.24-2.203q1.455-.822 3.36-.821 1.942 0 3.285.858 1.382.86 2.091 2.614a6.06 6.06 0 0 1 2.464-2.539q1.642-.933 3.621-.933 3.137 0 4.667 1.904 1.531 1.866 1.531 5.786v8.475q0 1.38-.747 2.128-.71.747-2.053.747-2.838 0-2.838-2.875v-8.288q0-1.83-.597-2.65-.56-.86-1.941-.86-1.605 0-2.502 1.12t-.896 3.174v7.504q0 2.874-2.8 2.875-1.344 0-2.09-.747-.747-.747-.747-2.128v-8.288q0-1.83-.597-2.65-.597-.86-1.942-.86-1.605 0-2.5 1.12-.897 1.12-.897 3.174v7.504q0 2.874-2.8 2.875"
          }
        ></path>

        <path
          fill={"#212529"}
          d={
            "M120.601 26.787q-.816 0-1.32-.504-.48-.504-.48-1.296 0-.768.48-1.248.504-.504 1.32-.504.84 0 1.296.504.48.48.48 1.248 0 .792-.48 1.296-.456.504-1.296.504m9.755.12q-1.848 0-3.216-.744a5.3 5.3 0 0 1-2.112-2.16q-.744-1.392-.744-3.264t.744-3.216a5 5 0 0 1 2.112-2.088q1.368-.744 3.216-.744.792 0 1.704.216a5.8 5.8 0 0 1 1.752.72q.48.288.552.744.096.456-.12.84-.192.384-.6.552-.384.168-.888-.12-1.104-.624-2.136-.624-1.56 0-2.424.984-.84.96-.84 2.76 0 1.776.84 2.808.864 1.008 2.424 1.008 1.032 0 2.136-.6.504-.288.888-.12t.552.576q.168.384.072.84-.096.432-.552.72a6 6 0 0 1-1.68.696 7 7 0 0 1-1.68.216m6.856-.24q-.624 0-.936-.384a1.33 1.33 0 0 1-.264-.96q.048-.552.504-1.056l5.64-7.08h-5.088q-1.152 0-1.152-1.128t1.152-1.128h7.104q.72 0 1.056.384.36.384.312.936-.024.528-.48 1.032l-5.712 7.128h5.376q1.152 0 1.152 1.128t-1.152 1.128z"
          }
        ></path>
      </g>

      <defs>
        <clipPath id={"a"}>
          <path fill={"#fff"} d={"M0 0h146.667v28H0z"}></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default Logo1Svg2Icon;
/* prettier-ignore-end */
